<template lang="html">
    <div class="common-score">
        <div class="title">
            <span class="not-required" :class="required?'required':''">*</span>{{`评分项：${title}`}}<common-tooltip class="tooltip" v-if="tipCode" :tipCode="tipCode"></common-tooltip>
        </div>
        <div class="actions">
            <el-button :disabled="disabledDownload" @click="handleExport" type="primary" plain>数据下载</el-button>
            <el-upload
                ref="upload"
                :action="'http://'"
                :show-file-list="true"
                :accept="acceptType"
                :auto-upload="false"
                :on-change="valid"
                :on-remove="valid"
                :limit="1"    
                @click.native="e => disabledUpload?e.preventDefault():''"
                class="upload"
            >
                <el-button :disabled="disabledUpload" class="btn-upload" :class="error?'error':''" type="primary" plain>数据上传</el-button>
            </el-upload>          
        </div>
    </div>
</template>

<script>
import scoreExportApi from '@/api/bizmanagement/scoreExport';

export default {
    props: {
        'title': {
            type: String,
            required: true
        },
        'type': {//strategyHospital4Strategy, strategyOffice, strategyOffice, speakerMeetingType
            type: String,
            required: true
        },
        'fileName': {
            type: String,
            required: true
        },
        'getExportParams': {
            type: Function,
            required: true
        },
        'disabledDownload': {
            type: Boolean,
            required: false,
            default: false,
        },
        'required': {
            type: Boolean,
            required: false,
            default: false,
        },
        'tipCode': {
            type: String,
            required: false,
            default: '',
        },
    },
    data: function() {
        return {
            acceptType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
            error: false,
            disabledUpload: false
        }
    },
    methods: {
        handleExport() {
            let params = this.getExportParams();

            scoreExportApi[this.type](params)
                        .then(res => {
                                // 将`blob`对象转化成一个可访问的`url`
                                let url = window.URL.createObjectURL(new Blob([res.data]));
                                let link = document.createElement('a');
                                link.style.display = 'none';
                                link.href = url;
                                link.setAttribute('download', this.fileName);
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                            })
        },
        getFile() {
            return this.$refs.upload.uploadFiles[0]
        },
        clearFile() {
            if(this.$refs.upload) {
                this.$refs.upload.clearFiles();
                this.error = false;
                this.disabledUpload = false;
            }
        },
        valid() {
            this.disabledUpload = this.$refs.upload.uploadFiles.length > 0;

            if(this.$refs.upload.uploadFiles.length > 0) {
                this.$message.success('上传成功');
            }

            if(!this.required || this.$refs.upload.uploadFiles.length > 0) {
                this.error = false;
                return true;
            }
            else {
                this.error = true;
                return false;
            }
        }
    },
  };
</script>

<style lang="less" scoped>
    .title {
        margin-bottom: 10px;
    }

    .actions {
        display: flex;

        .upload {
            margin-left: 10px;
            width: 150px;
        }
    }
    .not-required {
        display: none;
    }
    
    .required {
        display: inline;
        color: #E64100;
        margin-right: 5px;
    }

    .btn-upload.error {
        border: 1px solid #e64100 !important;
    }

    .tooltip {
        margin-left: 5px;
    }
</style>


// WEBPACK FOOTER //
// CommonScore.vue?65a181b4